import { useState } from "react";
import PageWrapper from "../components/shared/PageWrapper";
import { useSocket } from "../contexts/SocketContext";
import TextInput from "../components/shared/inputs/TextInput";
import EditUserModal, { EditUserForm } from "../components/shared/modals/EditUserModal";
import { AceCard, AceLogo, LockIcon } from "../assets/icons";
import { Link } from "react-router-dom";
import Modal from "../components/Modal";

const LandingPage = () => {

  const {createRoom, joinRoom, passwordModal: joinPasswordModal, setPasswordModal, joinIntention, setJoinIntention} = useSocket();
  const [code, setCode] = useState(joinIntention?.toUpperCase() || '');
  const [password, setPassword] = useState('');

  const [editVisible, setEditVisible] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const handleCodeChange = (value: string) => {
    if (value.length > 6) return;

    if (joinIntention) setJoinIntention(null);
    setCode(value.toUpperCase())
  }

  const handleJoinRoom = () => {
    if (!code) return;
    joinRoom(code);
  };

  const createPasswordRoom = () => {
    if (!password) return;
    createRoom(password);
  }
  const joinPasswordRoom = () => {
    if (!joinPasswordModal) return;
    joinRoom(joinPasswordModal, password);
  }
  //handles both creating and joining passwords
  const clearPasswordRoom = () => {
    setPasswordVisible(false);
    setPasswordModal(false);
    setPassword("");
  }

  return (
    <>
      {editVisible && <EditUserModal setModalVisible={setEditVisible} />}
      {(joinPasswordModal || passwordVisible) && 
        <PasswordModal
          setModalVisible={joinPasswordModal ? setPasswordModal : setPasswordVisible}
          join={!!joinPasswordModal}
          value={password}
          setValue={setPassword}
          handleConfirm={joinPasswordModal ? joinPasswordRoom : createPasswordRoom}
          handleCancel={clearPasswordRoom}
        />
      }
      <PageWrapper padding={false} classNames="bottom-item-layout min-height height-vh">
        <div className="item-list" data-scroll={true}>
          <section className="item-list center-horizontal padding-large bottom-border secondary-border position-relative">
            <div className="hero-card">
              <AceCard />
            </div>
            <div className="item-list xl-gap position-absolute">
              <div className="item-list large-gap">
                <div className="icon-display hero">
                  <AceLogo />
                </div>
                <div className="item-list small-gap">
                  <h1 className="heading-small center">Chase the Ace</h1>
                  <p className="subheading-small weight-light center secondary">(a.k.a. Screw Your Neighbor)</p>
                </div>
              </div>
              <Link to="how" className="full-width item-row center-horizontal">
                <button className="subtle wide">How to Play</button>
              </Link>
            </div>
          </section>
          <section className="bottom-item-layout padding-large padding-bottom">
            <EditUserForm />
            <div className="item-row large-gap center-horizontal">
              <Link to={"faq"}><p className="subheading-small secondary-darker">FAQ</p></Link>
              <Link to={"privacy"}><p className="subheading-small secondary-darker">Privacy</p></Link>
              <Link to={"terms"}><p className="subheading-small secondary-darker">Terms</p></Link>
            </div>
          </section>
        </div>
        <section className="item-list padding top-border secondary-border">
          <TextInput
            secondary
            placeholder="Paste room code"
            id={'roomcode'}
            value={code}
            onChange={handleCodeChange}
            customButton="Join"
            customButtonClasses={!!joinIntention ? "pulse-animation" : undefined}
            customButtonHandler={handleJoinRoom}
            customButtonDisabled={code.length !== 6}
            hero
          />
          <div className="dual-button text-icon" aria-disabled={!!joinIntention}>
            <button className="highlight full-width" onClick={() => createRoom()}>
              Create Room
            </button>
            <button className="highlight" onClick={() => setPasswordVisible(true)}>
              <LockIcon />
            </button>
          </div>
        </section>
        
      </PageWrapper>
    </>
  );
};

type PasswordModalProps = {
  setModalVisible: (prev: false) => void;
  value: string;
  setValue: (prev: string) => void;
  handleConfirm: () => void;
  handleCancel: () => void;
  join?: boolean;
}

const PasswordModal = ({setModalVisible, join, value, setValue, handleConfirm, handleCancel}: PasswordModalProps) => {
  return (
    <Modal 
      setModalVisible={setModalVisible} 
      classNames="auto-height narrow"
      fixedBottomItem
      fixedBottomItemChildren={
        <div className="item-row padding-small">
          <button onClick={handleCancel} className="subtle full-width">Cancel</button>
          <button onClick={handleConfirm} className="primary full-width">{join ? "Join" : "Create"}</button>
        </div>
      }
      removePadding
      modalTitle={join ? "Join Locked Room" : "Create Locked Room"}
      controls={true}
      children={
        <div className="padding padding-top-small">
          <TextInput
            overrideType={join ? "password" : undefined}
            id={join ? "joinpassinput" : 'passinput'}
            value={value}
            onChange={value => setValue(value)}
            label={'Password'}
            onEnterKey={handleConfirm}
          />
        </div>
      }
    />
  )
}

export default LandingPage;